import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/property-default-image.png'


const _withScopeId = n => (_pushScopeId("data-v-4541ac9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "street-view-image" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "image"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-expand-alt" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_image, {
      class: "image",
      src: _ctx.imageSrc,
      fit: _ctx.fit
    }, {
      error: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["src", "fit"]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.expandStreetView && _ctx.expandStreetView(...args)), ["stop"])),
      class: "expand-icon d-flex align-items-center justify-content-center"
    }, _hoisted_4)
  ]))
}